<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveTag()" autocomplete="off">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Nome da TAG</label>
                <input
                  id="name"
                  v-model="tag.name"
                  name="name"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.tag.name.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.tag.name.required"
                  class="invalid-feedback"
                >
                  O campo nome é obrigatório.
                </div>
              </div>
            </div>
          </div>

          <!-- Bloco de estimativa pra modo Feira (dashboard analítico) -->
          <div v-if="isFairMode" class="estim-block">
            <div class="estim-head">
              <div>
                <h6 class="estim-title">Configuração de presença estimada</h6>
                <small class="estim-sub">
                  Marque as características desse estande. O dashboard estima quantas pessoas
                  estão no local agora baseado em check-ins recentes × tempo médio de permanência.
                </small>
              </div>
              <div class="estim-summary">
                <div class="estim-summary-item">
                  <span class="estim-summary-value">{{ estimatedDwell }}</span>
                  <span class="estim-summary-label">min permanência</span>
                </div>
                <div class="estim-summary-item">
                  <span class="estim-summary-value">{{ attractivenessScore }}</span>
                  <span class="estim-summary-label">score atratividade</span>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="estim-label">Tempo base (min)</label>
                  <select v-model.number="tag.dwell_base_minutes" class="form-control form-control-sm">
                    <option :value="1">1 — passagem rápida</option>
                    <option :value="2">2 — básico (padrão)</option>
                    <option :value="3">3 — abordagem leve</option>
                    <option :value="5">5 — comercial completo</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="estim-label">Tempo de fila (min)</label>
                  <select v-model.number="tag.queue_minutes" class="form-control form-control-sm">
                    <option :value="0">Sem fila</option>
                    <option :value="3">~3 min</option>
                    <option :value="5">~5 min</option>
                    <option :value="10">~10 min</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="estim-label">Fator de correção</label>
                  <select v-model.number="tag.correction_factor" class="form-control form-control-sm">
                    <option :value="0.7">0.70 — conservador</option>
                    <option :value="0.85">0.85 — recomendado</option>
                    <option :value="1.0">1.00 — sem ajuste</option>
                    <option :value="1.5">1.50 — agressivo (poucos QRs lidos)</option>
                  </select>
                  <small class="text-muted" style="font-size:10px">
                    Ajusta a estimativa final. Padrão: 0.85.
                  </small>
                </div>
              </div>
            </div>

            <div class="estim-features">
              <label class="estim-feature feat-demo" :class="{ active: tag.has_demonstration }">
                <input type="checkbox" v-model="tag.has_demonstration"/>
                <span class="estim-feature-icon"><i class="bx bx-tv"></i></span>
                <div>
                  <div class="estim-feature-name">Demonstração</div>
                  <div class="estim-feature-bonus">+4 min</div>
                </div>
              </label>
              <label class="estim-feature feat-activation" :class="{ active: tag.has_activation }">
                <input type="checkbox" v-model="tag.has_activation"/>
                <span class="estim-feature-icon"><i class="bx bx-target-lock"></i></span>
                <div>
                  <div class="estim-feature-name">Ativação / interação</div>
                  <div class="estim-feature-bonus">+5 min</div>
                </div>
              </label>
              <label class="estim-feature feat-food" :class="{ active: tag.has_food }">
                <input type="checkbox" v-model="tag.has_food"/>
                <span class="estim-feature-icon"><i class="bx bx-coffee"></i></span>
                <div>
                  <div class="estim-feature-name">Café / comida</div>
                  <div class="estim-feature-bonus">+8 min</div>
                </div>
              </label>
              <label class="estim-feature feat-gift" :class="{ active: tag.has_giveaway }">
                <input type="checkbox" v-model="tag.has_giveaway"/>
                <span class="estim-feature-icon"><i class="bx bx-gift"></i></span>
                <div>
                  <div class="estim-feature-name">Brinde</div>
                  <div class="estim-feature-bonus">+2 min</div>
                </div>
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveTag()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

const DEFAULT_TAG = () => ({
  name: '',
  dwell_base_minutes: 2,
  has_demonstration: false,
  has_activation: false,
  has_food: false,
  has_giveaway: false,
  queue_minutes: 0,
  correction_factor: 0.85
})

export default {
  components: { Loading },
  props: {
    idTag: { type: Number || String, default: null }
  },
  data () {
    return {
      title: 'Nova Tag',
      loading: true,
      fullPage: true,
      submitted: false,
      tag: DEFAULT_TAG(),
      modal: false
    }
  },
  validations: {
    tag: {
      name: { required }
    }
  },
  computed: {
    ...mapState('tag', { data: 'tag' }),
    ...mapState('settingEvent', { eventSetting: 'setting' }),
    isFairMode () {
      return (this.eventSetting && this.eventSetting.event_type) === 'fair'
    },
    /**
     * Espelha o cálculo do backend (Tag::estimatedDwellMinutes).
     * Atualiza em tempo real conforme o usuário marca features.
     */
    estimatedDwell () {
      const t = this.tag || {}
      let d = parseInt(t.dwell_base_minutes, 10) || 2
      if (t.has_demonstration) d += 4
      if (t.has_activation) d += 5
      if (t.has_food) d += 8
      if (t.has_giveaway) d += 2
      d += parseInt(t.queue_minutes, 10) || 0
      return Math.max(1, d)
    },
    attractivenessScore () {
      const t = this.tag || {}
      let s = 0
      if (t.has_food) s += 3
      if (t.has_activation) s += 2
      if (t.has_demonstration) s += 2
      if (t.has_giveaway) s += 1
      return s
    }
  },
  methods: {
    ...mapActions('tag', {
      getTag: 'show',
      postData: 'save'
    }),
    ...mapActions('settingEvent', { GetSetting: 'GetSetting' }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Tag'
        this.getTag(id).then(() => {
          // Merge com defaults pra cobrir tags antigas sem features
          this.tag = { ...DEFAULT_TAG(), ...(this.data || {}) }
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      this.GetSetting() // garante que isFairMode reflete config atual
      if (id) {
        this.loadItem(id)
        return
      }
      this.tag = DEFAULT_TAG()
      this.loading = false
    },
    async saveTag () {
      this.submitted = true
      this.$v.tag.$touch()
      if (this.$v.tag.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      await this.postData(this.tag).then(() => {
        successMessage('Sucesso: Dados armazenados com sucesso.', 2500)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.tag = DEFAULT_TAG()
      this.$v.$reset()
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.vld-overlay.is-full-page {
  z-index: 1051 !important;
}

.estim-block {
  margin-top: 8px;
  padding: 16px 18px;
  background: #fafbfc;
  border: 1px solid #eef0f6;
  border-radius: 12px;
}

.estim-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.estim-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1d26;
  margin: 0 0 4px 0;
}

.estim-sub {
  font-size: 11px;
  color: #8b90a5;
  display: block;
  max-width: 540px;
  line-height: 1.5;
}

.estim-summary {
  display: flex;
  gap: 10px;
}

.estim-summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 14px;
  background: #fff;
  border: 1px solid #eaecf2;
  border-radius: 10px;
  min-width: 90px;
}

.estim-summary-value {
  font-size: 22px;
  font-weight: 800;
  color: #556ee6;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.estim-summary-label {
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
  color: #8b90a5;
  margin-top: 2px;
}

.estim-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
  color: #4a5068;
  margin-bottom: 4px;
}

.estim-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-top: 6px;
}

.estim-feature {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #fff;
  border: 1.5px solid #eaecf2;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  margin: 0;

  input[type="checkbox"] {
    margin: 0;
    accent-color: #556ee6;
  }

  &:hover { border-color: #d4d8e3; }

  &.active {
    border-color: #556ee6;
    background: rgba(85, 110, 230, 0.05);
  }
}

.estim-feature-icon {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1;

  i { font-size: 16px; }
}

.feat-demo .estim-feature-icon       { background: rgba(85, 110, 230, 0.12); color: #556ee6; }
.feat-activation .estim-feature-icon { background: rgba(139, 92, 246, 0.12); color: #8b5cf6; }
.feat-food .estim-feature-icon       { background: rgba(241, 180, 76, 0.16); color: #b8801f; }
.feat-gift .estim-feature-icon       { background: rgba(236, 72, 153, 0.12); color: #ec4899; }

.estim-feature-name {
  font-size: 12px;
  font-weight: 600;
  color: #1a1d26;
}

.estim-feature-bonus {
  font-size: 10px;
  color: #8b5cf6;
  font-weight: 700;
}
</style>
